import { createBasicLocation } from "src/router/routeTypes"

const GuestAccess = createBasicLocation("/guest_access")

export const GuestAccessRoutes = {
  GuestAccess,
} as const
